import type { TTopicList } from 'types/microlearning'

export const filterTopics = (topics: TTopicList[], searchQuery: string) => {
  const query = searchQuery.trim().toLowerCase()
  if (!query) return topics

  return topics.filter(
    (topic) =>
      topic.name?.toLowerCase().includes(query) ||
      topic.description?.toLowerCase().includes(query) ||
      topic.tags?.some((tag) => tag.trim().toLowerCase() === query)
  )
}
